export default () => next => action => {
  try {
    return next(action)
  } catch (err) {
    console.error("Exception!", err) // eslint-disable-line no-console
    throw err
  }
}
